import * as XLSX from 'xlsx';

const formatDate = (value: string) => {
    if (!value) return '';
    const d = new Date(value);
    if (isNaN(d.getTime())) return '';
    return d.toLocaleDateString('en-gb', { day: '2-digit', month: 'short', year: 'numeric' });
};

export const CashDetailExport = (data: any[]) => {
    const headers = [
        'Order #',
        'Invoice #',
        'Invoice Date',
        'Invoice By',
        'Customer',
        'Ph No',
        'Courier Charges (₹)',
        'Handling Charges (₹)',
        'Payment Gateway Charges (₹)',
        'Discount Amount (₹)',
        'Gross Amount (₹)',
        'Reward Amount (₹)',
        'Final Amount (₹)',
    ];

    const rows = data.map((row) => [
        row.orderID ?? '',
        row.invoiceNo ?? '',
        formatDate(row.invoiceDate),
        row.invoiceBy ?? '',
        row.customerName ?? '',
        row.primaryContactNo ?? '',
        row.courierCharges != null ? Math.round(row.courierCharges) : '',
        row.handlingCharges != null ? Math.round(row.handlingCharges) : '',
        row.paymentGatewayCharges != null ? Math.round(row.paymentGatewayCharges) : '',
        row.discountAmount != null ? Math.round(row.discountAmount) : '',
        row.grossAmount != null ? Math.round(row.grossAmount) : '',
        row.rewardAmount != null ? Math.round(row.rewardAmount) : '',
        row.finalAmount != null ? Math.round(row.finalAmount) : '',
    ]);

    const aoaData = [headers, ...rows];
    const ws = XLSX.utils.aoa_to_sheet(aoaData);

    // Bold header row
    headers.forEach((_, idx) => {
        const cellRef = XLSX.utils.encode_cell({ r: 0, c: idx });
        if (ws[cellRef]) {
            ws[cellRef].s = { font: { bold: true } };
        }
    });

    // Column widths
    ws['!cols'] = [
        { wch: 10 }, // Order #
        { wch: 12 }, // Invoice #
        { wch: 14 }, // Invoice Date
        { wch: 16 }, // Invoice By
        { wch: 22 }, // Customer
        { wch: 14 }, // Ph No
        { wch: 20 }, // Courier Charges
        { wch: 20 }, // Handling Charges
        { wch: 26 }, // Payment Gateway Charges
        { wch: 20 }, // Discount Amount
        { wch: 18 }, // Gross Amount
    ];

    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Cash Report');

    const now = new Date();
    const fileName = `Cash_Report_${now.toISOString().slice(0, 10)}.xlsx`;
    XLSX.writeFile(wb, fileName);
};
